import apiClient from "./apiClient"; // Asegúrate de que la ruta es correcta

const requestsEndpoint = "/requests";

export const getAllRequests = async () =>
  apiClient.get(requestsEndpoint).then((res) => res.data);

export const getRequestsByFilter = async (filters) => {
  // Axios maneja la conversión de objetos a parámetros de URL automáticamente.
  // Nota: Si tu backend espera específicamente que los arrays/objetos dentro
  // de los filtros estén como strings JSON, esta forma es la correcta.
  const params = {
    ...filters,
    requestBuildingType: JSON.stringify(filters.requestBuildingType),
    requestAdType: JSON.stringify(filters.requestAdType),
  };
  return apiClient
    .get(`${requestsEndpoint}/filter`, { params: params })
    .then((res) => res.data);
};

export const getRequestById = async (id) =>
  apiClient.get(`${requestsEndpoint}/${id}`).then((res) => res.data);

export const getAllRequestByConsultantId = async (id) =>
  apiClient.get(`${requestsEndpoint}/consultant/${id}`).then((res) => res.data);

export const getRequestByContacts = async (id) =>
  apiClient.get(`${requestsEndpoint}/contact/${id}`).then((res) => res.data);

export const getLastReference = async () => {
  // Mantenemos async/await aquí para poder aplicar tu lógica personalizada.
  const lastReference = await apiClient
    .get(`${requestsEndpoint}/lastReference`)
    .then((res) => res.data);

  let lr = 0;
  if (lastReference !== 0) lr = lastReference + 1;
  else lr = 1;
  return lr;
};

export const getAdsMatched = async (id) =>
  apiClient.get(`${requestsEndpoint}/matching/${id}`).then((res) => res.data);

export const createRequest = async (form) =>
  apiClient.post(`${requestsEndpoint}/create`, form).then((res) => res.data);

export const updateRequest = async (form) =>
  apiClient.put(`${requestsEndpoint}/edit`, form).then((res) => res.data);

export const updateManyConsultantsRequets = async (req, currentConsultantId) =>
  apiClient
    .put(`${requestsEndpoint}/editmanyconsultant/${currentConsultantId}`, req)
    .then((res) => res.data);

export const deleteRequest = async (id) =>
  apiClient.delete(`${requestsEndpoint}/delete/${id}`).then((res) => res.data);

export const sendNewRequest = async (form) =>
  apiClient
    .post(`${requestsEndpoint}/matching/new`, form)
    .then((res) => res.data);
